import { FC, useEffect, useState } from 'react';
import { LABEL_CONSTANTS, TABLE_HEADER_CONSTANTS } from '../../constants/common';
import { EmbryoStraw } from '../../types/interfaces';

export interface SelectedEmbryoStraw {
  embryoStrawId: number;
  quantity: number;
  selected: boolean;
}

interface SelectEmbryoStrawsProps {
  embryoStraws: EmbryoStraw[];
  onChange: (selected: SelectedEmbryoStraw[], totalQuantity: number) => void;
}

const SelectEmbryoStraws: FC<SelectEmbryoStrawsProps> = ({ embryoStraws, onChange }) => {
  const [selectedRows, setSelectedRows] = useState<SelectedEmbryoStraw[]>([]);

  useEffect(() => {
    if (!embryoStraws) return;
    const initRows = embryoStraws.map((straw: EmbryoStraw) => ({
      embryoStrawId: straw.embryoStrawId,
      quantity: 0,
      selected: false,
    }));
    setSelectedRows(initRows);
  }, [embryoStraws]);

  useEffect(() => {
    const initRows: SelectedEmbryoStraw[] = embryoStraws.map((straw: EmbryoStraw) => ({
      embryoStrawId: straw.embryoStrawId,
      quantity: 0,
      selected: false,
    }));

    setSelectedRows(initRows);
  }, []);

  const handleCheckboxChange = (index: number, checked: boolean) => {
    const updatedSelectedRows = [...selectedRows];
    const selectedStraw = embryoStraws[index];

    updatedSelectedRows[index].selected = checked;
    updatedSelectedRows[index].quantity = checked ? selectedStraw.embryoCountPerStraw ?? 0 : 0;

    setSelectedRows(updatedSelectedRows);

    const selectedEmbryoStraws = updatedSelectedRows.filter(row => row.selected);
    const totalSelectedQuantity = selectedEmbryoStraws.reduce((acc, row) => acc + row.quantity, 0);

    onChange(selectedEmbryoStraws, totalSelectedQuantity);
  };

  const totalQuantity = selectedRows.reduce(
    (totalQuantitySum, selectedRow) => (selectedRow.selected ? totalQuantitySum + selectedRow.quantity : totalQuantitySum),
    0,
  );

  return (
    <div className="specimen-table embryo-straws-table">
      <table>
        <thead>
          <tr>
            <th>{TABLE_HEADER_CONSTANTS.SELECT}</th>
            <th>{TABLE_HEADER_CONSTANTS.STRAW_LOT}</th>
            <th>{TABLE_HEADER_CONSTANTS.STRAW_NUMBER}</th>
            <th>{TABLE_HEADER_CONSTANTS.EMBRYO_GRADE}</th>
            <th>{TABLE_HEADER_CONSTANTS.EMBRYO_STAGE}</th>
            <th>{TABLE_HEADER_CONSTANTS.QUANTITY}</th>
          </tr>
        </thead>
        <tbody>
          {embryoStraws?.length ? (
            embryoStraws.map((straw: EmbryoStraw, index: number) => (
              <tr key={straw.embryoStrawId}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows[index]?.selected || false}
                    onChange={e => handleCheckboxChange(index, e.target.checked)}
                  />
                </td>
                <td>{straw.embryoStrawCode}</td>
                <td>{straw.embryoStrawNumber ?? '-'}</td>
                <td>{straw.embryoGrade || '-'}</td>
                <td>{straw.embryoStage ?? '-'}</td>
                <td>{straw.embryoCountPerStraw ?? '-'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} style={{ textAlign: 'center' }}>
                {LABEL_CONSTANTS.NO_RESULTS_FOUND}
              </td>
            </tr>
          )}
          <tr>
            <td colSpan={5}>{LABEL_CONSTANTS.TOTAL_QUANTITY}:</td>
            <td>{totalQuantity}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SelectEmbryoStraws;
